type RuntimeAppConfig = {
  MODE?: "development" | "production";
};

declare global {
  interface Window {
    APP_CONFIG?: RuntimeAppConfig;
  }
}

const appConfig = typeof window !== "undefined" ? window.APP_CONFIG : undefined;
const isDev = appConfig?.MODE === "development";

export const isDevelopment = isDev;

export const runtimeConfig = {
  apiBase: isDev ? "http://localhost:8081/api/runtime" : "/api/runtime",
} as const;
